import Row from 'components/Row';
import Page from 'components/Page';
import ResultTable from './ResultTable';
import { ResultContainer } from './styled';
import { getPublishedExams, getSearchResult } from './firebase';
import { Typography } from '@material-ui/core';
import SearchPart from 'components/SearchPart';
import React, { useEffect, useState } from 'react';
import FullScreenLoader from 'components/Loaders/FullScreenLoader';
import HeaderBanner from 'components/headerBanner/HeaderBanner';

export default function ResultPage({ history }) {
  let [exams, setExams] = useState(null);
  let [sorry, setSorry] = useState(false);

  useEffect(() => {
    pullPublishedExams();
  }, []);

  async function pullPublishedExams() {
    var exams = await getPublishedExams();
    setExams(exams);
  }

  const onViewResultClick = examKey => {
    history.push('/result/' + examKey.trim());
  };

  const searchOnClick = async value => {
    let searchResult = await getSearchResult(value);
    if (searchResult) {
      setSorry(false);
      setExams(searchResult);
    } else {
      setSorry(true);
    }
  };

  if (!exams) return <FullScreenLoader />;
  return (
    <>
      <HeaderBanner
        title="Result"
        subtitle="Check the result of exam you appeared."
      />
      <Page>
        <ResultContainer>
          <Row
            align="center"
            justify="space-between"
            marginbottom="30px"
            flexDirection="column-reverse"
          >
            <Typography style={{ fontWeight: 'bold' }} variant="h4">
              Published Results
            </Typography>
            <SearchPart
              placeholder="Search Exams"
              onClick={value => searchOnClick(value)}
            />
          </Row>
          {sorry === true ? (
            <h6>Sorry, there are no any data associated with your search</h6>
          ) : (
            <ResultTable exams={exams} onViewResultClick={onViewResultClick} />
          )}
        </ResultContainer>
      </Page>
    </>
  );
}
